/**
 * 省市级联选择器 匹配工具
 */

/**
 * 归一化搜索关键字：全角转半角、去首尾空格、统一小写
 * 使「广东」「廣東」「ｇｕａｎｇ」等写法都能命中
 */
export function normalizeKeyword (keyword: string): string {
  if (!keyword) return ''
  return keyword
    // 全角字符（！-～）转半角
    .replace(/[！-～]/g, char => String.fromCharCode(char.charCodeAt(0) - 0xFEE0))
    // 全角空格转半角空格
    .replace(/\u3000/g, ' ')
    .trim()
    .toLowerCase()
}

/**
 * 判断省市名称是否命中关键字，包含匹配（非前缀匹配）
 */
export function matchAreaKeyword (name: string, keyword: string): boolean {
  return normalizeKeyword(name).includes(normalizeKeyword(keyword))
}
